//const Backofficebff         : string = "/api";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const ReturnCommand: any = {
    PostGetReturnList: Backofficebff + '/v1/return/getreturnlist',
    PostCheckReturnAvailability: Backofficebff + '/v1/return/checkreturnavailability',
    PostGetShippingListReturnItems: Backofficebff + '/v1/return/getshippinglistreturnitems',
    CompleteAndConfirmReturn: Backofficebff + '/v1/return/completeandconfirmreturn',
    SearchReturn: Backofficebff + '/v1/return/searchreturn',
    CancelReturn: Backofficebff + '/v1/return/cancelreturn',
    ResetReturn: Backofficebff + '/v1/return/resetreturn',
    SimulateReturn: Backofficebff + '/v1/return/simulatereturn',
    SimulateReturnRest: Backofficebff + '/v1/return/simulatereturnrest',
    CreateReturn: Backofficebff + '/v1/return/createreturn',
    UpdateReturnStatus: Backofficebff + '/v1/return/updatereturnstatus',
    SearchStoreReturns: Backofficebff + '/v1/return/searchstorereturns',
    ReturnStatusHistory: Backofficebff + '/v1/return/return-status-history',
    GetReturnStatusChangeMatrixList: Backofficebff + '/v1/return/get-return-status-change-matrix-list',
    GetReturnStatusChangeMatrixListWithRole:
        Backofficebff + '/v1/return/get-return-status-change-matrix-list-with-role',
    ChangeReturnStatus: Backofficebff + '/v1/return/change-return-status',
    AddOrUpdateReturnStatusForManagement: Backofficebff + '/v1/return/add-return-status-for-management',
    GetAllOperatorsWithSelectedStatus: Backofficebff + '/v1/return/get-all-operators-with-selected-status',
    GetMPReturnCargoLabelPdf: Backofficebff + '/v1/return/get-mp-return-cargo-label-pdf',
    CreateDocument: Backofficebff + '/v1/return/create-document',
    GetReturnDispatchDocumentNo: Backofficebff + '/v1/return/get-return-dispatch-document-no',
    GetReturnTrackingInfo: Backofficebff + '/v1/return/get-return-tracking-info',
    GetReturnProductList: Backofficebff + '/v1/return/get-return-product-list',
    CreateReturnForLostCargo: Backofficebff + '/v1/return/create-return-for-lost-cargo',
    GetReturnDetailByReturnIdForLostCargo: Backofficebff + '/v1/return/get-return-detail-by-returnId-for-lost-cargo',
    CompleteReturnForLostCargo: Backofficebff + '/v1/return/complete-return-for-lost-cargo',
    SearchStoreReturnsWithIpLogs: Backofficebff + '/v1/return/search-store-returns-with-ip-logs',
};
